'use client';

import { Link } from "@/i18n/navigation";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";

export default function HotelAbout({ item }) {
  const t = useTranslationDetector('hotel');
  if (!item) return null;

  const totalHotels = item?.TotalHotels || 0;
  const popularHotel = item?.PopularHotel || null;

  // Eğer TotalHotels 0 ve PopularHotel yoksa, component'i render etme
  if (totalHotels === 0 && !popularHotel) {
    return null;
  }

  const popularHotelName = popularHotel?.Name || t('popularHotel');
  const popularHotelUrl = popularHotel?.RedirectUrl || "#";

  return (
    <div className="bg-background-global border border-border-card rounded-lg flex flex-col sm:flex-row  sm:h-[105px] md:!h-[137px]">
      {/* Left Section - Total Hotel Count */}
      <div className="flex-1 flex flex-col items-center justify-center border-b sm:border-r sm:border-b-0 border-primary-weak p-6 lg:py-10">
        <p className="text-foreground font-normal text-lg mb-[5px]">{t('totalHotelCount')}</p>
        <p className="text-foreground text-lg font-semibold">{totalHotels.toLocaleString('tr-TR')}</p>
      </div>

      {/* Right Section - Popular Hotel */}
      <div className="flex-1 flex flex-col items-center justify-center p-6 lg:py-10">
        <p className="text-foreground font-normal text-lg mb-[5px]">{t('popularHotel')}</p>
        {popularHotel && popularHotelUrl !== "#" ? (
          <Link
            href={popularHotelUrl}
            className="text-foreground text-lg font-semibold text-center hover:text-primary transition-colors"
          >
            {popularHotelName}
          </Link>
        ) : (
          <p className="text-foreground text-lg font-semibold text-center">{popularHotelName}</p>
        )}
      </div>
    </div>
  );
}
